import React from 'react';
import COProductCard from 'shared/components/COProductCard';
import commodityProfile from 'assets/images/company_men.svg';
import { ChildProduct } from 'models/ChildProduct/childProduct.model';

const CommodityAPPComponent = () => {
  const commodityProducts: ChildProduct[] = [
    {
      commodityId: 1,
      uniqueId: 'PROD001',
      name: 'Organic Beans',
      isNew: true,
      b2c: 1,
      brandName: 'Morning Brew',
      stage: 2,
      reportingPeriod: '2024-Q1',
      processingFacilityName: 'Coffee Processing Unit 1',
      status: 'approved',
      image: commodityProfile,
    },
    {
      commodityId: 2,
      uniqueId: 'PROD002',
      name: 'Tea Leaves',
      isNew: false,
      b2c: 0,
      brandName: 'Tea Masters',
      stage: 3,
      reportingPeriod: '2024-Q1',
      processingFacilityName: 'Tea Processing Facility',
      status: 'draft',
      image: commodityProfile,
    },
    {
      commodityId: 3,
      uniqueId: 'PROD003',
      name: 'Cocoa Beans',
      isNew: true,
      b2c: 1,
      brandName: 'Cocoa Express',
      stage: 1,
      reportingPeriod: '2024-Q1',
      processingFacilityName: 'Cocoa Processing Unit 3',
      status: 'declined',
      image: commodityProfile,
    },
    {
      commodityId: 4,
      uniqueId: 'PROD004',
      name: 'Vanilla Pods',
      isNew: false,
      b2c: 1,
      brandName: 'Pure Vanilla',
      stage: 4,
      reportingPeriod: '2024-Q1',
      processingFacilityName: 'Vanilla Processing Center',
      status: 'in review',
      image: commodityProfile,
    },
  ];

  return (
    <>
      <div className="mt-2 mb-10 ">
        <h2>Commodity Card</h2>
        <div
          className="mt-5 ml-5 mb-5 mr-5"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '1rem',
          }}>
          {commodityProducts.map(commodity => (
            <COProductCard
              data={commodity}
              onCopyClick={() => {}}
              navigateProductOverview={() => {}}
              calenderRow={true}
              showStatus={true}
              multiRowCard={true}
              commodityCard={true}
              showDownloadOptions={commodity.status}
            />
          ))}
        </div>
      </div>
      <div className="mt-2 mb-10 ">
        <h2>Commodity Details Card</h2>
        <div
          className="mt-5 ml-5 mb-5 mr-5"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '1rem',
          }}>
          {commodityProducts.map(commodity => (
            <COProductCard
              data={commodity}
              onCopyClick={() => {}}
              navigateProductOverview={() => {}}
              calenderRow={true}
              showStatus={true}
              multiRowCard={true}
              commodityCard={true}
              commodityDetailsCard={true}
              showDownloadOptions={commodity.status}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default CommodityAPPComponent;
